
<template>
  <div class="timeline_content">
    <div class="timeline_title">
      {{ $t("about_us.our_honors.content.title") }}
    </div>
    <div class="timeline_list">
      <div
        v-for="(item, index) in timelineItems"
        :key="index"
        :class="[
          item.year % 2 === 1 ? 'left' : 'right',
          { marginTop: item.year === '2016' },
        ]"
      >
        <div class="item">
          <div
            class="circle"
            :style="{ top: item.year === '2021' ? '50px' : '' }"
          >
            <img
              width="36px"
              height="36px"
              src="@/assets/images/serviceAbility/time_line_circle.png"
            />
          </div>
          <div class="item_text">
            <div class="img_box row row-gutter-15">
              <div
                v-for="(image, imgIndex) in imageMap[item.year]"
                :key="imgIndex"
                :class="[
                  ['2019', '2023'].includes(item.year) ? 'land' : '',
                  ['2015', '2016', '2017'].includes(item.year)
                    ? 'land_first'
                    : '',

                  'col-4',
                ]"
              >
                <img :src="image" />
              </div>
            </div>
            <div class="text_box">
              <div class="text_year">
                {{ item.year + $t("about_us.our_honors.content.unit") }}
              </div>
              <div
                v-for="(desc, descIndex) in item.history_list"
                :key="descIndex"
                class="text_desc"
              >
                {{ desc }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TimeLine",

  data() {
    return {
      imageMap: {},
    };
  },
  computed: {
    timelineItems() {
      return this.$t("about_us.our_honors.timelineItems");
    },
  },
  created() {
    this.preloadImages();
  },
  methods: {
    /**
     * @description: 加载所有年份的图片,后续只需要维护文件夹中的图片即可
     */
    preloadImages() {
      try {
        const context = require.context(
          "@/assets/images/timeline",
          true, // 递归查找子目录
          /\.(png|jpg|jpeg)$/i
        );
        this.imageMap = {};
        context.keys().forEach((key) => {
          const match = key.match(/\/(\d{4})\//);
          if (match) {
            const year = match[1];
            // 如果该年份还没有初始化，则创建空数组
            if (!this.imageMap[year]) {
              this.imageMap[year] = [];
            }
            this.imageMap[year].push(context(key));
          }
        });
      } catch (error) {
        console.error("读取图片错误:", error);
        this.imageMap = {};
      }
    },
  },
};
</script>
